import {StackActions} from "@react-navigation/native";

export const goToUtil = (to, navigation, params) => {
    const pushAction = StackActions.push(to)
    navigation.dispatch(pushAction);
    navigation.navigate(to, params);
}
